import { Decodable } from './_decodable';

class ShareLink extends Decodable {
  static readonly TYPE_DEFAULT = 'default';
  static readonly TYPE_CUSTOM = 'custom';

  id?: number;
  title?: string;
  code?: string;
  type?: string;
  pageLink?: string;
  isDefault?: boolean;
  isActive?: boolean;
  isBlocked?: boolean;
  createdAt?: Date;

  protected _map = {
    createdAt: (e) => this.parseDate(e),
  };
}

export { ShareLink };
